
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/filme/[slug]",
      function () {
        return require("private-next-pages/filme/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/filme/[slug]"])
      });
    }
  